import { Navigate } from "react-router";
import { AdminLayout } from "@/views/layouts/AppLayout";
import { DeviceClaimPage } from "@/views/pages/logistics/deviceClaim/DeviceClaimPage";
import { DeviceClaimDetailPage } from "@/views/pages/logistics/deviceClaim/DeviceClaimDetailPage";
import { DeviceClaimFormPage } from "@/views/pages/logistics/deviceClaim/DeviceClaimFormPage";
import { InstallPromotionRecordPage } from "@/views/pages/logistics/installPromotionRecord/InstallPromotionRecordPage";
import { InstallPromotionRecordDetailPage } from "@/views/pages/logistics/installPromotionRecord/InstallPromotionRecordDetailPage";
import { InstallPromotionRecordFormPage } from "@/views/pages/logistics/installPromotionRecord/InstallPromotionRecordFormPage";
import { FeaturesFeedbackPage } from "@/views/pages/logistics/featuresFeedback/FeaturesFeedbackPage";
import { FeaturesFeedbackDetailPage } from "@/views/pages/logistics/featuresFeedback/FeaturesFeedbackDetailPage";
import { EmptyShipInformationPage } from "@/views/pages/logistics/emptyShipInformation/EmptyShipInformationPage";
import { EmptyShipInformationDetailPage } from "@/views/pages/logistics/emptyShipInformation/EmptyShipInformationDetailPage";
import { EmptyShipInformationFormPage } from "@/views/pages/logistics/emptyShipInformation/EmptyShipInformationFormPage";
import { EmptyShipInformationEditPage } from "@/views/pages/logistics/emptyShipInformation/EmptyShipInformationEditPage";
import { DeviceManagementPage } from "@/views/pages/logistics/deviceManagement/DeviceManagementPage";
import { DeviceManagementDetailPage } from "@/views/pages/logistics/deviceManagement/DeviceManagementDetailPage";
import { DeviceManagementFormPage } from "@/views/pages/logistics/deviceManagement/DeviceManagementFormPage";
import { DeviceManagementEditPage } from "@/views/pages/logistics/deviceManagement/DeviceManagementEditPage";
import { PortManagementPage } from "@/views/pages/logistics/portWharfBerth/PortManagementPage";
import { PortManagementFormPage } from "@/views/pages/logistics/portWharfBerth/PortManagementFormPage";
import { PortManagementDetailPage } from "@/views/pages/logistics/portWharfBerth/PortManagementDetailPage";
import { WharfManagementPage } from "@/views/pages/logistics/portWharfBerth/WharfManagementPage";
import { WharfManagementFormPage } from "@/views/pages/logistics/portWharfBerth/WharfManagementFormPage";
import { WharfManagementDetailPage } from "@/views/pages/logistics/portWharfBerth/WharfManagementDetailPage";
import { BerthManagementPage } from "@/views/pages/logistics/portWharfBerth/BerthManagementPage";
import { BerthManagementFormPage } from "@/views/pages/logistics/portWharfBerth/BerthManagementFormPage";
import { BerthManagementDetailPage } from "@/views/pages/logistics/portWharfBerth/BerthManagementDetailPage";
import { ShipInfoPage } from "@/views/pages/logistics/shipManagement/ShipInfoPage";
import { ShipInfoDetailPage } from "@/views/pages/logistics/shipManagement/ShipInfoDetailPage";
import { ShipInfoEditPage } from "@/views/pages/logistics/shipManagement/ShipInfoEditPage";
import { ShipContactInformationUploadPage } from "@/views/pages/logistics/shipManagement/ShipContactInformationUploadPage";
import { ShipWaterGaugeBulkUploadPage } from "@/views/pages/logistics/shipManagement/ShipWaterGaugeBulkUploadPage";
import { ShipCertificationPage } from "@/views/pages/logistics/shipManagement/ShipCertificationPage";
import { ShipCertificationDetailPage } from "@/views/pages/logistics/shipManagement/ShipCertificationDetailPage";
import { PlatformShipNeedPage } from "@/views/pages/logistics/shippingNeeds/PlatformShipNeedPage";
import { PlatformShipNeedDetailPage } from "@/views/pages/logistics/shippingNeeds/PlatformShipNeedDetailPage";
import { PlatformShipNeedFormPage } from "@/views/pages/logistics/shippingNeeds/PlatformShipNeedFormPage";
import { WaybillManagementPage } from "@/views/pages/logistics/shippingNeeds/WaybillManagementPage";
import { WaybillManagementDetailPage } from "@/views/pages/logistics/shippingNeeds/WaybillManagementDetailPage";
import { WaybillManagementFormPage } from "@/views/pages/logistics/shippingNeeds/WaybillManagementFormPage";
import { PlatformShipInviteMapPage } from "@/views/pages/logistics/shippingNeeds/PlatformShipInviteMapPage";
import { OilSitePage } from "@/views/pages/logistics/oil/OilSitePage";
import { OilSiteFormPage } from "@/views/pages/logistics/oil/OilSiteFormPage";
import { OilSiteDetailPage } from "@/views/pages/logistics/oil/OilSiteDetailPage";
import { OilOrderPage } from "@/views/pages/logistics/oil/OilOrderPage";
import { OilOrderDetailPage } from "@/views/pages/logistics/oil/OilOrderDetailPage";
import { OilOrderFormPage } from "@/views/pages/logistics/oil/OilOrderFormPage";
import { FindLocationPage } from "@/views/pages/logistics/findLocation/FindLocationPage";
import { FindLocationDetailPage } from "@/views/pages/logistics/findLocation/FindLocationDetailPage";
import { FindLocationTrackPage } from "@/views/pages/logistics/findLocation/FindLocationTrackPage";
import { TruckLocationPage } from "@/views/pages/logistics/truckLocation/TruckLocationPage";
import { ShippingOwnerCluesPage } from "@/views/pages/logistics/shippingOwnerClues/ShippingOwnerCluesPage";
import { ShippingOwnerCluesDetailPage } from "@/views/pages/logistics/shippingOwnerClues/ShippingOwnerCluesDetailPage";
import { PlatformCluesManagePage } from "@/views/pages/logistics/cluesManage/platformCluesManage/PlatformCluesManagePage";
import { PlatformCluesDetailPage } from "@/views/pages/logistics/cluesManage/platformCluesManage/PlatformCluesDetailPage";
import { ClueDashboardPage } from "@/views/pages/logistics/cluesManage/dashboard/ClueDashboardPage";
import { ElectronicFenceRecordPage } from "@/views/pages/logistics/electronicFenceRecord/ElectronicFenceRecordPage";
import { ElectronicFenceRecordDetailPage } from "@/views/pages/logistics/electronicFenceRecord/ElectronicFenceRecordDetailPage";
import { MonitorWarnPage } from "@/views/pages/logistics/monitor/monitorWarn/MonitorWarnPage";
import { MonitorWarnDetailPage } from "@/views/pages/logistics/monitor/monitorWarn/MonitorWarnDetailPage";
import { ModelDataPage } from "@/views/pages/logistics/monitor/modelData/ModelDataPage";
import { IdentifyRecordPage } from "@/views/pages/logistics/monitor/identifyRecord/IdentifyRecordPage";
import { IdentifyRecordDetailPage } from "@/views/pages/logistics/monitor/identifyRecord/IdentifyRecordDetailPage";
import { CapacityCertificationPage } from "@/views/pages/logistics/onlineTransportation/CapacityCertificationPage";
import { TransportCapacityManagementPage } from "@/views/pages/logistics/transportCapacityManagement/TransportCapacityManagementPage";
import { TransportCapacityDetailPage } from "@/views/pages/logistics/transportCapacityManagement/TransportCapacityDetailPage";
import { TransportCapacityFormPage } from "@/views/pages/logistics/transportCapacityManagement/TransportCapacityFormPage";
import type { AdminRouteObject } from "../index";

/** 物流管理路由，先接入用户反馈列表并沿用 Vue 权限码。 */
export const logisticsRoutes: AdminRouteObject = {
    path: "/logistics",
    element: <AdminLayout />,
    handle: { title: "物流管理" },
    children: [
        {
            // 沿用 Vue /logistics 的默认重定向，保证旧入口先落到码头管理。
            index: true,
            element: <Navigate replace to="wharf" />
        },
        {
            // 保留旧 Vue /logistics/wharf 地址，并转到当前 React 码头列表路径。
            path: "wharf",
            element: <Navigate replace to="portWharfBerth/wharfManagement" />
        },
        {
            // 沿用 Vue 查船入口及 ROLE_LF_SHIP 权限。
            path: "findLocation",
            element: <FindLocationPage />,
            handle: {
                title: "查船",
                permissions: ["ROLE_LF_SHIP", "ROLE_LF_SHIP_CUSTOMIZE", "ROLE_LF_SHIP_LIKE"]
            }
        },
        {
            // 保留旧 Vue 详情页的区域查船权限，详情页会据此展示区域查船入口。
            path: "findLocation/:mmsi",
            element: <FindLocationDetailPage />,
            handle: {
                title: "查船",
                permissions: ["ROLE_LF_SHIP", "ROLE_LF_SHIP_REGION", "ROLE_LF_SHIP_CUSTOMIZE", "ROLE_LF_SHIP_LIKE"]
            }
        },
        {
            path: "findTrack/:mmsi/:dateRange",
            element: <FindLocationTrackPage />,
            handle: {
                title: "查看轨迹",
                permissions: ["ROLE_LF_SHIP", "ROLE_LF_SHIP_CUSTOMIZE", "ROLE_LF_SHIP_LIKE"]
            }
        },
        {
            // 沿用 Vue 查车入口及 ROLE_LF_CAR 权限，车牌通过 query.vclN 传递。
            path: "truckLocation",
            element: <TruckLocationPage />,
            handle: { title: "查车", permissions: ["ROLE_LF_CAR"] }
        },
        {
            // 沿用 Vue 船舶信息列表入口和查看、管理、水尺表权限集合。
            path: "shipManage/shipInfo",
            element: <ShipInfoPage />,
            handle: { title: "船舶信息", permissions: ["ROLE_SHIP_R", "ROLE_SHIP_W", "ROLE_SHIP_M"] }
        },
        {
            // 沿用 Vue 船舶详情隐藏入口和查看权限。
            path: "shipManage/shipInfo/shipInfoDetail/:id",
            element: <ShipInfoDetailPage />,
            handle: { title: "船舶信息详情", permissions: ["ROLE_SHIP_R"] }
        },
        {
            // 沿用 Vue 船舶信息编辑历史路径和管理权限。
            path: "shipManage/shipInfo/shipInfoEdit/:id",
            element: <ShipInfoEditPage />,
            handle: { title: "修改船舶信息", permissions: ["ROLE_SHIP_W"] }
        },
        {
            // 沿用 Vue 船舶绑定历史路径和管理权限。
            path: "shipManage/shipInfo/shipInfoBind/:id/:band",
            element: <ShipInfoEditPage />,
            handle: { title: "绑定船舶", permissions: ["ROLE_SHIP_W"] }
        },
        {
            // 沿用 Vue 船舶联系方式导入历史路径和导入权限。
            path: "shipManage/shipInfo/contactInformationUpload",
            element: <ShipContactInformationUploadPage />,
            handle: { title: "联系方式导入", permissions: ["ROLE_SHIP_I"] }
        },
        {
            // 沿用 Vue 水尺表导入历史路径和管理权限。
            path: "shipManage/shipInfo/waterGaugeBulkUploads/:shipId",
            element: <ShipWaterGaugeBulkUploadPage />,
            handle: { title: "水尺表导入", permissions: ["ROLE_SHIP_W", "ROLE_SHIP_M"] }
        },
        {
            // 沿用 Vue 认证审核列表入口和审核权限。
            path: "shipManage/shipCertification",
            element: <ShipCertificationPage />,
            handle: { title: "认证审核", permissions: ["ROLE_SHIP_REVIEW"] }
        },
        {
            path: "shipManage/shipCertification/info/:id",
            element: <ShipCertificationDetailPage />,
            handle: { title: "船舶认证详情", permissions: ["ROLE_SHIP_REVIEW"] }
        },
        {
            path: "shipManage/shipCertification/apply/:id",
            element: <ShipCertificationDetailPage />,
            handle: { title: "审核船舶认证", permissions: ["ROLE_SHIP_REVIEW"] }
        },
        {
            // 沿用 Vue 平台船运需求列表入口和需求处理权限。
            path: "shippingNeed/platformShipNeed",
            element: <PlatformShipNeedPage />,
            handle: {
                title: "平台船运需求",
                permissions: ["ROLE_SHIP_DEMAND_R", "ROLE_SHIP_DEMAND_DEAL", "ROLE_SHIP_DEMAND_MANAGE"]
            }
        },
        {
            // 沿用 Vue 平台船运需求详情隐藏入口和查看权限。
            path: "shippingNeed/platformShipNeedInfo/:id",
            element: <PlatformShipNeedDetailPage />,
            handle: { title: "船运需求发布详情", permissions: ["ROLE_SHIP_DEMAND_R"] }
        },
        {
            // 沿用 Vue 新增平台船运需求路径和处理权限。
            path: "shippingNeed/platformShipNeedAdd",
            element: <PlatformShipNeedFormPage />,
            handle: { title: "新增船运需求", permissions: ["ROLE_SHIP_DEMAND_DEAL"] }
        },
        {
            // 沿用 Vue 编辑平台船运需求路径和处理权限。
            path: "shippingNeed/platformShipNeedEdit/:id",
            element: <PlatformShipNeedFormPage />,
            handle: { title: "修改船运需求", permissions: ["ROLE_SHIP_DEMAND_DEAL"] }
        },
        {
            // 保留 Vue platformShipNeedAdd/:id? 的带 id 历史入口。
            path: "shippingNeed/platformShipNeedAdd/:id",
            element: <PlatformShipNeedFormPage />,
            handle: { title: "新增船运需求", permissions: ["ROLE_SHIP_DEMAND_DEAL"] }
        },
        {
            // 沿用 Vue 自定义邀请地图入口和查看、邀请权限。
            path: "shippingNeed/platformShipInviteShipMap/:id",
            element: <PlatformShipInviteMapPage />,
            handle: { title: "自定义邀请", permissions: ["ROLE_SHIP_DEMAND_R", "ROLE_SHIP_INVITE"] }
        },
        {
            // 沿用 Vue 加油站点列表和查看、管理权限。
            path: "oil/oilSite",
            element: <OilSitePage />,
            handle: { title: "站点管理", permissions: ["ROLE_GAS_STATION_R", "ROLE_GAS_STATION_W"] }
        },
        {
            // 沿用 Vue 新增站点路径和管理权限。
            path: "oil/oilSiteAdd",
            element: <OilSiteFormPage />,
            handle: { title: "新增站点", permissions: ["ROLE_GAS_STATION_W"] }
        },
        {
            // 沿用 Vue 编辑站点路径和管理权限。
            path: "oil/oilSiteEdit/:id",
            element: <OilSiteFormPage />,
            handle: { title: "修改站点", permissions: ["ROLE_GAS_STATION_W"] }
        },
        {
            // 沿用 Vue 站点详情隐藏路径和查看权限。
            path: "oil/OilSiteDetail/:id",
            element: <OilSiteDetailPage />,
            handle: { title: "站点详情", permissions: ["ROLE_GAS_STATION_R"] }
        },
        {
            // 沿用 Vue 油品订单列表的查看权限，处理/管理按钮由页面内权限单独控制。
            path: "oil/oilTypeManagement",
            element: <OilOrderPage />,
            handle: {
                title: "油品订单",
                permissions: ["ROLE_GAS_ORDER_R"]
            }
        },
        {
            // 沿用 Vue 油品订单详情隐藏路径和查看权限。
            path: "oil/oilTypeManagement/detail/:id",
            element: <OilOrderDetailPage />,
            handle: { title: "油品订单详情", permissions: ["ROLE_GAS_ORDER_R"] }
        },
        {
            // 沿用 Vue 新增油品订单路径和查看权限，页面操作仍由业务按钮权限控制。
            path: "oil/oilTypeManagement/add",
            element: <OilOrderFormPage />,
            handle: { title: "新增油品订单", permissions: ["ROLE_GAS_ORDER_R"] }
        },
        {
            // 沿用 Vue 核对油品订单路径和查看权限，页面操作仍由业务按钮权限控制。
            path: "oil/oilTypeManagement/check/:id",
            element: <OilOrderFormPage />,
            handle: { title: "核对油品订单", permissions: ["ROLE_GAS_ORDER_R"] }
        },
        {
            // 沿用 Vue 船运单管理列表路径和查看、运输、管理权限。
            path: "shippingNeed/waybillManagement",
            element: <WaybillManagementPage />,
            handle: {
                title: "船运单管理",
                permissions: [
                    "ROLE_SHIP_ORDER_R",
                    "ROLE_SHIP_ORDER_DEAL",
                    "ROLE_SHIP_ORDER_MANAGE",
                    "ROLE_SHIP_ORDER_CLOSE",
                    "ROLE_YUJIANG_REV_R",
                    "ROLE_YUJIANG_REV_W"
                ]
            }
        },
        {
            // 沿用 Vue 船运单详情隐藏路径和查看权限。
            path: "shippingNeed/waybillManagementInfo/:id",
            element: <WaybillManagementDetailPage />,
            handle: { title: "船运单详情", permissions: ["ROLE_SHIP_ORDER_R", "ROLE_YUJIANG_REV_R"] }
        },
        {
            // 沿用 Vue 船运单新增路径和处理权限。
            path: "shippingNeed/waybillManagementAdd",
            element: <WaybillManagementFormPage />,
            handle: { title: "新增船运单", permissions: ["ROLE_SHIP_ORDER_MANAGE"] }
        },
        {
            // 沿用 Vue 船运单编辑路径和处理权限。
            path: "shippingNeed/waybillManagementEdit/:id",
            element: <WaybillManagementFormPage />,
            handle: { title: "修改船运单", permissions: ["ROLE_SHIP_ORDER_MANAGE"] }
        },
        {
            path: "emptyShipInformation",
            element: <EmptyShipInformationPage />,
            handle: {
                title: "空船信息",
                permissions: ["ROLE_EMPTY_SHIP_R", "ROLE_EMPTY_SHIP_MANAGE", "ROLE_EMPTY_SHIP_DEAL"]
            }
        },
        {
            path: "emptyShipInformationDetail/:id",
            element: <EmptyShipInformationDetailPage />,
            handle: { title: "空船详情", permissions: ["ROLE_EMPTY_SHIP_R"] }
        },
        {
            path: "emptyShipInformationAdd",
            element: <EmptyShipInformationFormPage />,
            handle: { title: "新增空船信息", permissions: ["ROLE_EMPTY_SHIP_R"] }
        },
        {
            path: "emptyShipInformationEdit/:id",
            element: <EmptyShipInformationEditPage />,
            handle: { title: "编辑空船信息", permissions: ["ROLE_EMPTY_SHIP_R"] }
        },
        {
            path: "device/deviceManagement",
            element: <DeviceManagementPage />,
            handle: { title: "设备管理", permissions: ["ROLE_DEVICE_R", "ROLE_DEVICE_W", "ROLE_DEVICE_EXPORT"] }
        },
        {
            path: "device/deviceManagement/info/:id",
            element: <DeviceManagementDetailPage />,
            handle: { title: "设备详情", permissions: ["ROLE_DEVICE_R"] }
        },
        {
            path: "device/deviceManagement/add",
            element: <DeviceManagementFormPage />,
            handle: { title: "新增设备", permissions: ["ROLE_DEVICE_W"] }
        },
        {
            path: "device/deviceManagement/edit/:id",
            element: <DeviceManagementEditPage />,
            handle: { title: "编辑设备", permissions: ["ROLE_DEVICE_W"] }
        },
        {
            path: "deviceClaim",
            element: <DeviceClaimPage />,
            handle: { title: "设备认领", permissions: ["ROLE_DEVICE_BIND_R"] }
        },
        {
            // 保留 Vue 旧的设备认领层级路径。
            path: "device/deviceClaim",
            element: <DeviceClaimPage />,
            handle: { title: "设备认领", permissions: ["ROLE_DEVICE_BIND_R"] }
        },
        {
            path: "deviceClaim/info/:id",
            element: <DeviceClaimDetailPage />,
            handle: { title: "设备认领详情", permissions: ["ROLE_DEVICE_BIND_R"] }
        },
        {
            path: "device/deviceClaim/info/:id",
            element: <DeviceClaimDetailPage />,
            handle: { title: "设备认领详情", permissions: ["ROLE_DEVICE_BIND_R"] }
        },
        {
            path: "deviceClaim/form/:id",
            element: <DeviceClaimFormPage />,
            handle: { title: "设备认领处理", permissions: ["ROLE_DEVICE_BIND_W"] }
        },
        {
            path: "device/deviceClaim/form/:id",
            element: <DeviceClaimFormPage />,
            handle: { title: "设备认领处理", permissions: ["ROLE_DEVICE_BIND_W"] }
        },
        {
            path: "installPromotionRecord",
            element: <InstallPromotionRecordPage />,
            handle: { title: "安装推广记录", permissions: ["ROLE_DEVICE_RECORD_R"] }
        },
        {
            path: "installPromotionRecord/info/:id",
            element: <InstallPromotionRecordDetailPage />,
            handle: { title: "安装推广记录详情", permissions: ["ROLE_DEVICE_RECORD_R"] }
        },
        {
            path: "installPromotionRecord/add",
            element: <InstallPromotionRecordFormPage />,
            handle: { title: "新增安装推广记录", permissions: ["ROLE_DEVICE_RECORD_W"] }
        },
        {
            // 保留 Vue 旧的安装推广记录 form 地址。
            path: "installPromotionRecord/form",
            element: <InstallPromotionRecordFormPage />,
            handle: { title: "新增安装推广记录", permissions: ["ROLE_DEVICE_RECORD_W"] }
        },
        {
            // 保留 Vue /logistics/device 下的隐藏列表入口，兼容旧书签和外部跳转。
            path: "device/installPromotionRecord",
            element: <InstallPromotionRecordPage />,
            handle: { title: "安装推广记录", permissions: ["ROLE_DEVICE_RECORD_R"] }
        },
        {
            // 保留 Vue /logistics/device 下的安装推广记录详情入口。
            path: "device/installPromotionRecord/info/:id",
            element: <InstallPromotionRecordDetailPage />,
            handle: { title: "安装推广记录详情", permissions: ["ROLE_DEVICE_RECORD_R"] }
        },
        {
            // 保留 Vue /logistics/device 下的安装推广记录新增入口。
            path: "device/installPromotionRecord/form",
            element: <InstallPromotionRecordFormPage />,
            handle: { title: "新增安装推广记录", permissions: ["ROLE_DEVICE_RECORD_W"] }
        },
        {
            path: "featuresFeedback",
            element: <FeaturesFeedbackPage />,
            handle: { title: "用户反馈", permissions: ["ROLE_FUNCTION_R", "ROLE_FUNCTION_W"] }
        },
        {
            path: "portWharfBerth/portManagement",
            element: <PortManagementPage />,
            handle: { title: "港口管理", permissions: ["ROLE_PORT_R", "ROLE_PORT_DEAL", "ROLE_PORT_W"] }
        },
        {
            path: "portWharfBerth/portAdd",
            element: <PortManagementFormPage />,
            handle: { title: "新增港口", permissions: ["ROLE_PORT_DEAL"] }
        },
        {
            path: "portWharfBerth/portEdit",
            element: <PortManagementFormPage />,
            handle: { title: "修改港口", permissions: ["ROLE_PORT_DEAL"] }
        },
        {
            path: "portWharfBerth/portDetail",
            element: <PortManagementDetailPage />,
            handle: { title: "港口详情", permissions: ["ROLE_PORT_R"] }
        },
        {
            path: "portWharfBerth/wharfManagement",
            element: <WharfManagementPage />,
            handle: { title: "码头管理", permissions: ["ROLE_TERMINAL_R", "ROLE_TERMINAL_DEAL", "ROLE_TERMINAL_W"] }
        },
        {
            path: "portWharfBerth/wharfAdd",
            element: <WharfManagementFormPage />,
            handle: { title: "新增码头", permissions: ["ROLE_TERMINAL_DEAL"] }
        },
        {
            path: "portWharfBerth/wharfEdit",
            element: <WharfManagementFormPage />,
            handle: { title: "修改码头", permissions: ["ROLE_TERMINAL_DEAL"] }
        },
        {
            path: "portWharfBerth/wharfDetail",
            element: <WharfManagementDetailPage />,
            handle: { title: "码头详情", permissions: ["ROLE_TERMINAL_R"] }
        },
        {
            path: "portWharfBerth/berthManagement",
            element: <BerthManagementPage />,
            handle: { title: "泊位管理", permissions: ["ROLE_BERTH_R", "ROLE_BERTH_DEAL", "ROLE_BERTH_W"] }
        },
        {
            path: "portWharfBerth/berthAdd",
            element: <BerthManagementFormPage />,
            handle: { title: "新增泊位", permissions: ["ROLE_BERTH_DEAL"] }
        },
        {
            path: "portWharfBerth/berthEdit",
            element: <BerthManagementFormPage />,
            handle: { title: "修改泊位", permissions: ["ROLE_BERTH_DEAL"] }
        },
        {
            path: "portWharfBerth/berthDetail",
            element: <BerthManagementDetailPage />,
            handle: { title: "泊位详情", permissions: ["ROLE_BERTH_R"] }
        },
        {
            // 保留 Vue 旧的泊位详情入口名称。
            path: "portWharfBerth/berthInfo",
            element: <BerthManagementDetailPage />,
            handle: { title: "泊位详情", permissions: ["ROLE_BERTH_R"] }
        },
        {
            path: "featuresFeedback/info/:id",
            element: <FeaturesFeedbackDetailPage />,
            handle: { title: "反馈详情", permissions: ["ROLE_FUNCTION_R", "ROLE_FUNCTION_W"] }
        },
        {
            path: "cluesManage/shippingOwnerClues",
            element: <ShippingOwnerCluesPage />,
            handle: { title: "船主线索", permissions: ["ROLE_SHIP_CLUE_R", "ROLE_SHIP_CLUE_W"] }
        },
        {
            path: "cluesManage/shippingOwnerCluesDetail/:id",
            element: <ShippingOwnerCluesDetailPage />,
            handle: { title: "船主线索详情", permissions: ["ROLE_SHIP_CLUE_R"] }
        },
        {
            // 沿用 Vue 线索大屏路径和独立的查看/管理权限。
            path: "cluesManage/cluesDashboard",
            element: <ClueDashboardPage />,
            handle: {
                title: "平台线索大屏",
                permissions: ["ROLE_PLATFORM_CLUE_SCREEN_R", "ROLE_PLATFORM_CLUE_SCREEN_W"]
            }
        },
        {
            path: "cluesManage/platformCluesManage",
            element: <PlatformCluesManagePage />,
            handle: { title: "平台线索管理", permissions: ["ROLE_PLATFORM_CLUE_R", "ROLE_PLATFORM_CLUE_W"] }
        },
        {
            path: "cluesManage/platformCluesManage/detail/:id",
            element: <PlatformCluesDetailPage />,
            handle: { title: "平台线索管理详情", permissions: ["ROLE_PLATFORM_CLUE_R"] }
        },
        {
            path: "cluesManage/electronicFenceRecord",
            element: <ElectronicFenceRecordPage />,
            handle: { title: "电子围栏记录", permissions: ["ROLE_ELECTRIC_FENCE_R", "ROLE_ELECTRIC_FENCE_W"] }
        },
        {
            path: "cluesManage/electronicFenceRecord/:id",
            element: <ElectronicFenceRecordDetailPage />,
            handle: { title: "记录详情", permissions: ["ROLE_ELECTRIC_FENCE_R"] }
        },
        {
            path: "monitor/monitorWarn",
            element: <MonitorWarnPage />,
            handle: { title: "监控预警", permissions: ["ROLE_WARNING_R", "ROLE_WARNING_MANAGE", "ROLE_WARNING_DEAL"] }
        },
        {
            path: "monitor/monitorWarn/:id",
            element: <MonitorWarnDetailPage />,
            handle: { title: "监控预警详情", permissions: ["ROLE_WARNING_R"] }
        },
        {
            path: "monitor/modelData",
            element: <ModelDataPage />,
            handle: { title: "模型数据", permissions: ["ROLE_MODEL_DATA_R", "ROLE_MODEL_DATA_W"] }
        },
        {
            path: "monitor/identifyRecord",
            element: <IdentifyRecordPage />,
            handle: { title: "识别记录", permissions: ["ROLE_MODEL_DATA_LOG_R", "ROLE_MODEL_DATA_LOG_W"] }
        },
        {
            path: "monitor/identifyRecord/:id",
            element: <IdentifyRecordDetailPage />,
            handle: { title: "识别记录详情", permissions: ["ROLE_MODEL_DATA_LOG_R"] }
        },
        {
            path: "onlineTransportation/capacityCertification",
            element: <CapacityCertificationPage />,
            handle: { title: "运力认证", permissions: ["ROLE_ONLINE_FREIGHT_R"] }
        },
        {
            path: "transportCapacityManagement/capacityManagement",
            element: <TransportCapacityManagementPage />,
            handle: { title: "运力管理", permissions: ["ROLE_CM_R", "ROLE_CM_M"] }
        },
        {
            path: "transportCapacityManagement/capacityManagement/detail/:id",
            element: <TransportCapacityDetailPage />,
            handle: { title: "运力详情", permissions: ["ROLE_CM_R", "ROLE_CM_M"] }
        },
        {
            // 保留 Vue 旧的运力详情短路径。
            path: "transportCapacityManagement/detail/:id",
            element: <TransportCapacityDetailPage />,
            handle: { title: "运力详情", permissions: ["ROLE_CM_R", "ROLE_CM_M"] }
        },
        {
            path: "transportCapacityManagement/capacityManagement/addCapacity",
            element: <TransportCapacityFormPage />,
            handle: { title: "新增运力", permissions: ["ROLE_CM_M"] }
        }
    ]
};

export default logisticsRoutes;
